export enum FeedType {
  STORE_NEWS = 'STORE_NEWS',
  PRODUCTS_NEWS = 'PRODUCTS_NEWS',
}
